import React, { Component } from "react";
import ModalePhoto from "../fiche-enfant/les-tabs/ModalePhoto";
import srcIconPhoto from "../../../../styles/img/icon-photo.svg";
import imgUrl from "../../../../styles/img/icon-baby-grey-little.svg";
import emptyLogo from "../../../../styles/img/icon-default-logo.png";
import srcIconCheck from "../../../../styles/img/icon-check-white.svg";
import Img from "react-image";
import moment from "moment";
import _ from "lodash";
import PlanningCreche from "./PlanningCreche";
import ModalHoraires from "../fiche-enfant/les-tabs/ModalHoraires";
import { connect } from "react-redux";
import { getInfosCreche, putInfosCreche, updateLogoCreche } from "./infoCreche.ducks";
import {
  getFermetures,
  postFermetures,
  deleteFermetures,
} from "./planningCreche.ducks";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import DateFnsUtils from "@date-io/moment"; // choose your lib
import ModalDeleteFermeture from "./ModalDeleteFermeture";
import { isMobile } from "react-device-detect";
import { makeStyles } from "@material-ui/core/styles";
import "../../kids-list/fiche-enfant/les-tabs/style.css";
import UploadMobile from "../fiche-enfant/les-tabs/UploadMobile";
import { API } from "../../../../const";
import { Service } from "../../../service/service";
import { withTranslation } from 'react-i18next';

const materialTheme = createMuiTheme({
  palette: {
    primary: { main: "#1d4cc5" },
  },
  overrides: {
    MuiInputBase: {
      root: {
        position: "relative",
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none",
        padding: "0 15px",
        fontWeight: "600",
        fontSize: "18px",
        color: "#000",
      },
      input: {
        textAlign: "center",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none !important",
        fontWeight: "normal",
        fontSize: "18px",
        color: "#000",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },
      },
    },
  },
});
const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;

const IconPhoto = () => (
  <object data={srcIconPhoto} type="image/svg+xml" className="img-fluid" />
);
var divStyle = {
  backgroundImage: "url(" + imgUrl + ")",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
};
function notEmpty(value) {
  return !_.isEmpty(value);
}

class InfoCreche extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numJour: 0,
      horaire: "",
      nomEtablissement: "",
      capacite: "",
      email: "",
      numeroTel: "",
      rue: "",
      codePostal: "",
      ville: "",
      pays: "FRANCE",
      formErrors: { sexe: "", email: "", numeroTel: "", nomEtablissement: "" },
      emailValid: false,
      numeroTelValid: false,
      formValid: false,
      photoChanged: false,
      newHoraires: {
        MONDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: props.t('days.LUNDI'),
        },
        TUESDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: props.t('days.MARDI'),
        },
        WEDNESDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: props.t('days.MERCREDI'),
        },
        THURSDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: props.t('days.JEUDI'),
        },
        FRIDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: props.t('days.VENDREDI'),
        },
        SATURDAY: {
          ouvert: false,
          horaireDebut: moment().format("HH[h]mm"),
          horaireFin: moment().format("HH[h]mm"),
          nameOfDay: props.t('days.SAMEDI'),
        },
        SUNDAY: {
          ouvert: false,
          horaireDebut: null,
          horaireFin: null,
          nameOfDay: props.t('days.DIMANCHE'),
        },
      },
      infosUtiles: "",
      ModalHoraires: false,
      horaireDebut: moment(),
      horaireFin: moment(),
      ModaleArchivage: false,
      ModaleSuppresion: false,
      ModalePhoto: false,
      showModalCancel: false,
      showModalConfirm: false,
      lienPhoto: "",
      startDate: null,
      endDate: null,
      textarea: "",
      initialized: false,
      ModalDeleteFermeture: false,
      firstTime: true,
      ModalePhoto: false,
      prefix: {
        capacite: false,
        seuilStaffingGlobal: false,
        seuilRampeursParAgent: false,
        seuilMarcheursParAgent: false,
      },
      dynLeft: {
        capacite: 4,
        seuilStaffingGlobal: 4,
        seuilRampeursParAgent: 4,
        seuilMarcheursParAgent: 4,
      },
      fileId: "",
      croppedFile: "",
      modalUploadMobile: false,
      pays: "",
      seuilStaffingGlobal: "",
      seuilRampeursParAgent: "",
      seuilMarcheursParAgent: "",
      showPhoto: null,
    };
    this.showModalHoraires = this.showModalHoraires.bind(this);
    this.onCloseHorraires = this.onCloseHorraires.bind(this);
    this.onSubmitModal = this.onSubmitModal.bind(this);
    this.handleChangeHoraire = this.handleChangeHoraire.bind(this);
    this.handleChangeTimeStart = this.handleChangeTimeStart.bind(this);
    this.handleChangeTimeEnd = this.handleChangeTimeEnd.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDateStart = this.handleChangeDateStart.bind(this);
    this.handleChangeDateEnd = this.handleChangeDateEnd.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClickFermeture = this.handleClickFermeture.bind(this);
    this.handleCloseFermeture = this.handleCloseFermeture.bind(this);
    this.onSubmitSuppression = this.onSubmitSuppression.bind(this);
    this.validateField = this.validateField.bind(this);
    this.handleSubmitInfos = this.handleSubmitInfos.bind(this);
    this.renderContent = this.renderContent.bind(this);
    this.showModalPhoto = this.showModalPhoto.bind(this);
    this.onCloseModalePhoto = this.onCloseModalePhoto.bind(this);
    this.uploadPhoto = this.uploadPhoto.bind(this);
    this.onSelectFile = this.onSelectFile.bind(this);
    this.getCroppedImage = this.getCroppedImage.bind(this);
    this.uploadPhotoMobile = this.uploadPhotoMobile.bind(this);
    this.onCloseUploadMobile = this.onCloseUploadMobile.bind(this);
  }
  onCloseUploadMobile() {
    this.setState({ modalUploadMobile: false, file: "" });
  }

  uploadPhotoMobile = (e) => {
    e.preventDefault();
    let tok = localStorage.getItem("token");
    const formData = new FormData();
    formData.append("file", this.state.croppedFile);
    const response = Service.post(
      `${API}api/creche/files?category=PHOTO`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${tok}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    response.then((res) => {
      setTimeout(() => {}, 400);
      this.setState({
        fileId: res.data.files[0].fileId,
        lienPhoto: this.state.croppedFile,
        modalUploadMobile: false,
        photoChanged: true
      });
      this.props.updateLogoCreche(
        localStorage.getItem("token"),
        this.state.fileId
        )
    });
    response.catch((err) => {
      console.log(err);
    });
  };
  getCroppedImage(file) {
    this.setState({ croppedFile: file });
  }
  showModalPhoto() {
    this.setState({ ModalePhoto: true });
  }
  onCloseModalePhoto() {
    this.setState({ ModalePhoto: false });
  }
  componentDidMount() {
    if (!_.isEmpty(this.props.dataCreche)) {
      let { rue, pays, ville, codePostal } = this.props.dataCreche.adresseCreche
        ? this.props.dataCreche.adresseCreche
        : { rue: null, pays: null, ville: null, codePostal: null };
      let email = this.props.dataCreche.email
        ? this.props.dataCreche.email
        : "";
      let nom = this.props.dataCreche.nom ? this.props.dataCreche.nom : "";
      let capacite = this.props.dataCreche.capacite
        ? this.props.dataCreche.capacite
        : "";
      let prefix = {};
      let dynLeft = {};
      let seuilStaffingGlobal = this.props.dataCreche.seuilStaffingGlobal
        ? this.props.dataCreche.seuilStaffingGlobal
        : "";
      let seuilRampeursParAgent = this.props.dataCreche.seuilRampeursParAgent
        ? this.props.dataCreche.seuilRampeursParAgent
        : "";
      let seuilMarcheursParAgent = this.props.dataCreche.seuilMarcheursParAgent
        ? this.props.dataCreche.seuilMarcheursParAgent
        : "";
      prefix.capacite = this.props.dataCreche.capacite ? true : false;
      prefix.seuilStaffingGlobal = this.props.dataCreche.seuilStaffingGlobal
        ? true
        : false;
      prefix.seuilRampeursParAgent = this.props.dataCreche.seuilRampeursParAgent
        ? true
        : false;
      prefix.seuilMarcheursParAgent = this.props.dataCreche
        .seuilMarcheursParAgent
        ? true
        : false;
      dynLeft.capacite = prefix.capacite
        ? String(this.props.dataCreche.capacite).split("").length * 0.5 + 5
        : 5;
      dynLeft.seuilStaffingGlobal = prefix.seuilStaffingGlobal
        ? String(this.props.dataCreche.seuilStaffingGlobal).split("").length *
            0.5 +
          5
        : 5;
      dynLeft.seuilRampeursParAgent = prefix.seuilRampeursParAgent
        ? String(this.props.dataCreche.seuilRampeursParAgent).split("").length *
            0.5 +
          5
        : 5;
      dynLeft.seuilMarcheursParAgent = prefix.seuilMarcheursParAgent
        ? String(this.props.dataCreche.seuilMarcheursParAgent).split("")
            .length *
            0.5 +
          5
        : 5;
      let numeroTel = this.props.dataCreche.numeroTel
        ? this.props.dataCreche.numeroTel
        : "";
      let horaire = "";
      let horaireDebut;
      let horaireFin;
      let numJour = _.isEmpty(this.props.dataCreche.horaires.horaires)
        ? ""
        : Array.from(_.values(this.props.dataCreche.horaires.horaires)).reduce(
            (accu, element) => {
              if (element.ouvert) {
                horaireDebut = moment(element.horaireDebut, "HH:mm:ss").format(
                  "HH[h]mm"
                );
                horaireFin = moment(element.horaireFin, "HH:mm:ss").format(
                  "HH[h]mm"
                );
                horaire =
                  (horaireDebut.charAt(0) === "0"
                    ? horaireDebut.slice(1)
                    : horaireDebut) +
                  "-" +
                  horaireFin;
              }
              return element.ouvert ? accu + 1 : accu;
            },
            0
          );
      let newHoraires = this.props.dataCreche.horaires.horaires
        ? this.props.dataCreche.horaires.horaires
        : this.state.newHoraires;
      let infosUtiles = this.props.dataCreche.horaires.horaires.infosUtiles
        ? this.props.dataCreche.horaires.horaires.infosUtiles
        : "";
      let logo = this.props.dataCreche.logoUrl
        ? this.props.dataCreche.logoUrl
        : emptyLogo;
      this.setState({
        rue: rue,
        pays: pays,
        ville: ville,
        codePostal: codePostal,
        nomEtablissement: nom,
        capacite: capacite,
        seuilStaffingGlobal: seuilStaffingGlobal,
        seuilRampeursParAgent: seuilRampeursParAgent,
        seuilMarcheursParAgent: seuilMarcheursParAgent,
        email: email,
        numeroTel: numeroTel,
        numJour: numJour,
        newHoraires: newHoraires,
        horaire: horaire,
        emailValid: false,
        numeroTelValid: false,
        horaireDebut: moment(horaireDebut, "HH[h]mm"),
        horaireFin: moment(horaireFin, "HH[h]mm"),
        infosUtiles: infosUtiles,
        logoCreche: logo,
        prefix: prefix,
        dynLeft: dynLeft,
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.dataCreche !== this.props.dataCreche) {
      let { rue, pays, ville, codePostal } = this.props.dataCreche.adresseCreche
        ? this.props.dataCreche.adresseCreche
        : { rue: null, pays: null, ville: null, codePostal: null };
      let email = this.props.dataCreche.email
        ? this.props.dataCreche.email
        : "";
      let nom = this.props.dataCreche.nom ? this.props.dataCreche.nom : "";
      let capacite = this.props.dataCreche.capacite
        ? this.props.dataCreche.capacite
        : "";
      let seuilStaffingGlobal = this.props.dataCreche.seuilStaffingGlobal
        ? this.props.dataCreche.seuilStaffingGlobal
        : "";
      let seuilRampeursParAgent = this.props.dataCreche.seuilRampeursParAgent
        ? this.props.dataCreche.seuilRampeursParAgent
        : "";
      let seuilMarcheursParAgent = this.props.dataCreche.seuilMarcheursParAgent
        ? this.props.dataCreche.seuilMarcheursParAgent
        : "";
      let prefix = {};
      let dynLeft = {};
      prefix.capacite = this.props.dataCreche.capacite ? true : false;
      prefix.seuilStaffingGlobal = this.props.dataCreche.seuilStaffingGlobal
        ? true
        : false;
      prefix.seuilRampeursParAgent = this.props.dataCreche.seuilRampeursParAgent
        ? true
        : false;
      prefix.seuilMarcheursParAgent = this.props.dataCreche
        .seuilMarcheursParAgent
        ? true
        : false;
      dynLeft.capacite = prefix.capacite
        ? String(this.props.dataCreche.capacite).length * 0.5 + 5
        : 5;
      dynLeft.seuilStaffingGlobal = prefix.seuilStaffingGlobal
        ? String(this.props.dataCreche.seuilStaffingGlobal).length * 0.5 + 5
        : 5;
      dynLeft.seuilRampeursParAgent = prefix.seuilRampeursParAgent
        ? String(this.props.dataCreche.seuilRampeursParAgent).length * 0.5 + 5
        : 5;
      dynLeft.seuilMarcheursParAgent = prefix.seuilMarcheursParAgent
        ? String(this.props.dataCreche.seuilMarcheursParAgent).length * 0.5 + 5
        : 5;
      let numeroTel = this.props.dataCreche.numeroTel
        ? this.props.dataCreche.numeroTel
        : "";
      let horaire = "";
      let horaireDebut;
      let horaireFin;
      let numJour = _.isEmpty(this.props.dataCreche.horaires.horaires)
        ? ""
        : Array.from(_.values(this.props.dataCreche.horaires.horaires)).reduce(
            (accu, element) => {
              if (element.ouvert) {
                horaireDebut = moment(element.horaireDebut, "HH:mm:ss").format(
                  "HH[h]mm"
                );
                horaireFin = moment(element.horaireFin, "HH:mm:ss").format(
                  "HH[h]mm"
                );
                horaire =
                  (horaireDebut.charAt(0) === "0"
                    ? horaireDebut.slice(1)
                    : horaireDebut) +
                  "-" +
                  horaireFin;
              }
              return element.ouvert ? accu + 1 : accu;
            },
            0
          );
      let newHoraires = this.props.dataCreche.horaires.horaires
        ? this.props.dataCreche.horaires.horaires
        : this.state.newHoraires;
      let infosUtiles = this.props.dataCreche.horaires.horaires.infosUtiles
        ? this.props.dataCreche.horaires.horaires.infosUtiles
        : "";
      let logo = this.props.dataCreche.logoUrl
        ? this.props.dataCreche.logoUrl
        : emptyLogo;
      this.setState({
        rue: rue,
        pays: pays,
        ville: ville,
        codePostal: codePostal,
        nomEtablissement: nom,
        capacite: capacite,
        seuilStaffingGlobal: seuilStaffingGlobal,
        seuilRampeursParAgent: seuilRampeursParAgent,
        seuilMarcheursParAgent: seuilMarcheursParAgent,
        email: email,
        numeroTel: numeroTel,
        numJour: numJour,
        newHoraires: newHoraires,
        horaire: horaire,
        emailValid: false,
        numeroTelValid: false,
        horaireDebut: moment(horaireDebut, "HH[h]mm"),
        horaireFin: moment(horaireFin, "HH[h]mm"),
        infosUtiles: infosUtiles,
        logoCreche: logo,
        prefix: prefix,
        dynLeft: dynLeft,
      });
    }
    if (prevProps.successMsg !== this.props.successMsg) {
      this.setState({
        startDate: null,
        endDate: null,
      });
    }
  }
  handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    let newPrefix = this.state.prefix;
    let dynLeft = this.state.dynLeft;
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      [name]: "",
    });
    dynLeft[name] = newPrefix[name]
      ? String(value).split("").length * 0.5 + 5
      : 5;
    if (_.isEmpty(value)) {
      this.setState({
        prefix: Object.assign({}, newPrefix, { [name]: false }),
        dynLeft: dynLeft,
      });
    } else {
      this.setState({
        prefix: Object.assign({}, newPrefix, { [name]: true }),
        dynLeft: dynLeft,
      });
    }
    this.setState({ [name]: value, formErrors: fieldValidationErrors }, () => {
      if (name === "email" || name === "numeroTel") {
        this.validateField(name, value);
      }
    });
  };
  handleChangeHoraire(name, day) {
    let arrayOfDays = [];
    let horaires = this.state.newHoraires;
    let newDay = day.ouvert
      ? Object.assign(day, { ouvert: false })
      : Object.assign(day, { ouvert: true });
    horaires[name] = Object.assign({}, newDay);
    this.setState({ newHoraires: Object.assign({}, horaires) });
  }
  showModalHoraires() {
    this.setState({ ModalHoraires: true });
  }
  onCloseHorraires() {
    this.setState({ ModalHoraires: false });
  }
  onSubmitModal() {
    let numJour = Array.from(_.values(this.state.newHoraires)).reduce(
      (accu, element) => {
        return element.ouvert ? accu + 1 : accu;
      },
      0
    );
    let horaireDebut = moment(this.state.horaireDebut).format("HH[h]mm");
    let horaireFin = moment(this.state.horaireFin).format("HH[h]mm");
    let newhoraire =
      horaireDebut.charAt(0) === "0"
        ? horaireDebut.slice(1) + "-" + horaireFin
        : horaireDebut + "-" + horaireFin;
    Object.keys(this.state.newHoraires).forEach((nameOfDay) => {
      this.state.newHoraires[nameOfDay] = Object.assign(
        {},
        this.state.newHoraires[nameOfDay],
        {
          horaireDebut: moment(this.state.horaireDebut, "HH[h]mm").format(
            "HH:mm:ss"
          ),
          horaireFin: moment(this.state.horaireFin, "HH[h]mm").format(
            "HH:mm:ss"
          ),
        }
      );
    });
    let fieldValidationErrors = Object.assign({}, this.state.formErrors, {
      ["numJour"]: "",
    });
    this.setState({
      ModalHoraires: false,
      numJour: numJour,
      horaire: newhoraire,
      formErrors: fieldValidationErrors,
    });
  }
  handleChangeTimeEnd(date) {
    this.setState(
      {
        horaireFin: moment(date),
      },
      () => {
        let horaireDebut = moment(this.state.horaireDebut).format("HH[h]mm");
        let horaireFin = moment(this.state.horaireFin).format("HH[h]mm");
        let horaire =
          horaireDebut.charAt(0) === "0"
            ? horaireDebut.slice(1) + "-" + horaireFin
            : horaireDebut + "-" + horaireFin;
        let newHoraires = this.state.newHoraires;
        Object.keys(newHoraires).forEach((nameOfDay) => {
          newHoraires[nameOfDay] = Object.assign({}, newHoraires[nameOfDay], {
            horaireFin: moment(this.state.horaireFin, "HH[h]mm").format(
              "HH:mm:ss"
            ),
          });
        });
        this.setState({ horaire: horaire, newHoraires: newHoraires });
      }
    );
  }
  handleChangeTimeStart(date) {
    this.setState(
      {
        horaireDebut: moment(date),
      },
      () => {
        let horaireDebut = moment(this.state.horaireDebut).format("HH[h]mm");
        let horaireFin = moment(this.state.horaireFin).format("HH[h]mm");
        let horaire =
          horaireDebut.charAt(0) === "0"
            ? horaireDebut.slice(1) + "-" + horaireFin
            : horaireDebut + "-" + horaireFin;
        let newHoraires = this.state.newHoraires;
        Object.keys(newHoraires).forEach((nameOfDay) => {
          newHoraires[nameOfDay] = Object.assign({}, newHoraires[nameOfDay], {
            horaireDebut: moment(this.state.horaireDebut, "HH[h]mm").format(
              "HH:mm:ss"
            ),
          });
        });

        this.setState({ horaire: horaire, newHoraires: newHoraires });
      }
    );
  }
  handleSubmit(event) {
    event.preventDefault();

    if (notEmpty(this.state.startDate) && notEmpty(this.state.endDate)) {
      let data = {
        commentaire: this.props.t('info_creche.closure_date'),
        debut: moment(this.state.startDate).format("YYYY-MM-DD[T]HH:mm:ssZ"),
        fin: moment(this.state.endDate).format("YYYY-MM-DD[T]HH:mm:ssZ"),
      };
      this.props.postFermetures(localStorage.getItem("token"), data);
    }
  }
  errorClass(error) {
    return _.isEmpty(error) ? "" : "error-mess";
  }
  validateField(name, value) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
    let numeroTelValid = this.state.numeroTelValid;
    switch (name) {
      case "email":
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        fieldValidationErrors.email = emailValid ? "" : "l'Email est invalide";
        break;
      case "numeroTel":
        numeroTelValid = value.match(/^((\+)33|033|0)[1-9](\d{2}){4}$/g);
        fieldValidationErrors.numeroTel = numeroTelValid
          ? ""
          : this.props.t('validation.phone_invalid_short');
        break;
    }
    let newObj = {
      ...this.state.formErrors,
      [name]: fieldValidationErrors[name],
    };
    this.setState(
      {
        formErrors: newObj,
        emailValid: emailValid,
        numeroTelValid: numeroTelValid,
      },
      this.validateForm
    );
  }
  renderInput = (props) => {
    let value = props.value ? props.value : "";

    return (
      <div className="col-md-6">
        <div className="form-group">
          <div className="container-select">
            <input
              readOnly
              className="form-control custom-input ipt-id-fin-fermeture"
              type="text"
              onClick={props.onClick}
              id={props.id}
              value={props.textLabel + value}
              {...props.inputProps}
            />
          </div>
        </div>
      </div>
    );
  };

  handleChangeDateStart = (date) => {
    this.setState({
      startDate: date,
    });
  };
  handleChangeDateEnd = (date) => {
    this.setState({
      endDate: date,
    });
  };
  handleStyle() {
    return notEmpty(this.state.startDate) && notEmpty(this.state.endDate)
      ? { opacity: 1 }
      : { opacity: 0.25, pointerEvents: "none" };
  }
  handleClickFermeture(obj) {
    this.setState({
      ModalDeleteFermeture: true,
      objFermeture: obj,
    });
  }
  handleCloseFermeture() {
    this.setState({
      ModalDeleteFermeture: false,
    });
  }
  onSubmitSuppression() {
    this.props.deleteFermetures(
      localStorage.getItem("token"),
      this.state.objFermeture.id
    );
    this.setState({ ModalDeleteFermeture: false });
  }
  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      let sizeInMB = (e.target.files[0].size / (1024 * 1024)).toFixed(2);
      if (sizeInMB > 5) {
        let name = "";
        let message = this.props.t('validation.photo_too_large');
        this.props.openSnackBar(name, message);
      } else {
        const reader = new FileReader();
        reader.addEventListener("load", () =>
          this.setState({
            file: reader.result,
            isUpload: true,
            modalUploadMobile: true,
          })
        );
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  };
  renderContent = () => {
    const classes = makeStyles((theme) => ({
      root: {
        "& > *": {
          margin: theme.spacing(1),
        },
      },
      input: {
        display: "none",
      },
    }));
    if (isMobile) {
      return (
        <div className={classes.root}>
          <input
            className={classes.input}
            id="contained-button-file"
            type="file"
            style={{ display: "none" }}
            onChange={this.onSelectFile}
            accept="image/png,image/bmp,image/jpeg"
          />

          <div className="input-file-style mr-3">
            <label
              htmlFor="contained-button-file"
              className="btn-photo btn-gradient"
            >
              <img src={srcIconPhoto} className="img-fluid" alt="" />{" "}
            </label>
          </div>
        </div>
      );
    }
    return (
      <button
        type="bouton"
        className="btn-photo btn-gradient"
        data-toggle="modal"
        data-target="#modalPhoto"
        onClick={(e) => this.showModalPhoto(e)}
      >
        <img src={srcIconPhoto} className="img-fluid" alt="" />
      </button>
    );
  };

  handleSubmitInfos() {
    let formErrors = this.state.formErrors;
    let validNomE = !_.isEmpty(this.state.nomEtablissement)
      ? ""
      : this.props.t('validation.field_required_short');
    let validRue = !_.isEmpty(this.state.rue) ? "" : this.props.t('validation.field_required_short');
    let validVille = !_.isEmpty(this.state.ville)
      ? ""
      : this.props.t('validation.field_required_short');
    let validCodePostal =
      !_.isEmpty(this.state.codePostal) && this.state.codePostal >= 0
        ? ""
        : this.state.codePostal < 0
        ? this.props.t('validation.field_cannot_be_negative')
        : this.props.t('validation.field_required_short');
    let validseuilStaffingGlobal =
      this.state.seuilStaffingGlobal && this.state.seuilStaffingGlobal >= 0
        ? ""
        : this.state.seuilStaffingGlobal < 0
        ? this.props.t('validation.field_cannot_be_negative')
        : this.props.t('validation.field_required_short');
    let validseuilRampeursParAgent =
      this.state.seuilRampeursParAgent && this.state.seuilRampeursParAgent >= 0
        ? ""
        : this.state.seuilRampeursParAgent < 0
        ? this.props.t('validation.field_cannot_be_negative')
        : this.props.t('validation.field_required_short');
    let validseuilMarcheursParAgent =
      this.state.seuilMarcheursParAgent &&
      this.state.seuilMarcheursParAgent >= 0
        ? ""
        : this.state.seuilMarcheursParAgent < 0
        ? this.props.t('validation.field_cannot_be_negative')
        : this.props.t('validation.field_required_short');
    let validCapacite =
      this.state.capacite >= 0 || this.state.capacite === ""
        ? ""
        : this.props.t('validation.field_cannot_be_negative');
    let validNumJour = this.state.numJour > 0 ? "" : this.props.t('validation.field_required_short');
    let validNum = _.isEmpty(this.state.numeroTel)
      ? this.props.t('validation.field_required_short')
      : this.state.formErrors.numeroTel;
    let validEmail = _.isEmpty(this.state.email)
      ? this.props.t('validation.field_required_short')
      : this.state.formErrors.email;
    let validPays = _.isEmpty(this.state.pays)
      ? this.props.t('validation.field_required_short')
      : this.state.formErrors.pays;
    let cleanHorraire = this.state.newHoraires;
    Object.keys(this.state.newHoraires).forEach((nameOfDay) => {
      delete cleanHorraire[nameOfDay].nameOfDay;
      delete cleanHorraire[nameOfDay].numDay;
    });
    let formValidForm =
      _.isEmpty(validNomE) &&
      _.isEmpty(validNum) &&
      _.isEmpty(validEmail) &&
      _.isEmpty(validRue) &&
      _.isEmpty(validVille) &&
      _.isEmpty(validCodePostal) &&
      _.isEmpty(validNumJour) &&
      _.isEmpty(validseuilStaffingGlobal) &&
      _.isEmpty(validseuilRampeursParAgent) &&
      _.isEmpty(validseuilMarcheursParAgent) &&
      _.isEmpty(validPays);

    if (formValidForm) {
      let data = {
        adresse: {
          rue: this.state.rue,
          pays: this.state.pays,
          ville: this.state.ville,
          codePostal: this.state.codePostal,
        },
        capacite: this.state.capacite,
        email: this.state.email,
        seuilStaffingGlobal: this.state.seuilStaffingGlobal,
        seuilRampeursParAgent: this.state.seuilRampeursParAgent,
        seuilMarcheursParAgent: this.state.seuilMarcheursParAgent,
        numeroTel: this.state.numeroTel,
        nom: this.state.nomEtablissement,
        horaires: {
          horaires: cleanHorraire,
          infosUtiles: this.state.infosUtiles,
        }
      };
      this.props.putInfosCreche(localStorage.getItem("token"), data);
      formErrors = Object.assign({}, formErrors, {
        nomEtablissement: "",
        rue: "",
        ville: "",
        codePostal: "",
        capacite: "",
        numJour: "",
        email: "",
        numeroTel: "",
        pays: "",
        validseuilStaffingGlobal: "",
        validseuilRampeursParAgent: "",
        validseuilMarcheursParAgent: "",
      });
    } else {
      formErrors = Object.assign({}, formErrors, {
        nomEtablissement: validNomE,
        rue: validRue,
        ville: validVille,
        codePostal: validCodePostal,
        capacite: validCapacite,
        numJour: validNumJour,
        numeroTel: validNum,
        email: validEmail,
        pays: validPays,
        seuilStaffingGlobal: validseuilStaffingGlobal,
        seuilRampeursParAgent: validseuilRampeursParAgent,
        seuilMarcheursParAgent: validseuilMarcheursParAgent,
      });
    }
    this.setState({ formErrors: formErrors });
  }
  uploadPhoto = (file) => {
    let tok = localStorage.getItem("token");
    // e.preventDefault();
    const formData = new FormData();
    formData.append("file", file);
    const response = Service.post(
      `${API}api/creche/files?category=PHOTO`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${tok}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    response.then((res) => {
      this.setState({
        fileId: res.data.files[0].fileId,
        showPhoto: file,
        photoChanged: true
      });
      this.props.updateLogoCreche(
        localStorage.getItem("token"),
        this.state.fileId
      )
    });
    response.catch((err) => {
      // dispatch({ type: UPLOAD_REJECTED, payload: err })
      // if (err && err.response && err.response.status === 401) {
      //     dispatch(unAuthorized())
      // }
    });
  };
  render() {
    var divStyle = (lienPhoto) => ({
      backgroundImage: "url(" + lienPhoto + ")",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    });

    return (
      <div className="tab-content p-0" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="infos-creche-pane"
          role="tabpanel"
          aria-labelledby="infos-creche-tab"
        >
          <div className="content p-0 pb-5">
            <div className="first-sections">
              <section className="content-section border-0 mb-0">
                <h2>{this.props.t('info_creche.establishment_info')}</h2>
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    <div className="row">
                      <div className="col-md-6 pr-0">
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`nomEtablissement`]
                          )}`}
                        >
                          <input
                            type="text"
                            id="nom-etablissement"
                            placeholder={this.props.t('info_creche.establishment_name')}
                            className="form-control box-shadow custom-input ipt-id-etablissement"
                            name="nomEtablissement"
                            onChange={this.handleChange}
                            value={this.state.nomEtablissement}
                          />
                          {(() => {
                            if (
                              !_.isEmpty(
                                this.state.formErrors["nomEtablissement"]
                              )
                            ) {
                              return (
                                <p>
                                  {this.state.formErrors["nomEtablissement"]}
                                </p>
                              );
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div
                            className="capacite"
                            style={{
                              left: this.state.dynLeft["capacite"] + "em",
                              display: this.state.prefix["capacite"]
                                ? "inline"
                                : "none",
                            }}
                          ></div>
                          <input
                            type="number"
                            id="nb-enfants-creche"
                            placeholder={this.props.t('info_creche.capacity')}
                            className="form-control box-shadow custom-input ipt-id-nom"
                            onChange={this.handleChange}
                            name="capacite"
                            value={
                              this.state.capacite > 0 ? this.state.capacite : ""
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div
                          className="row align-items-center row-horaires"
                          data-toggle="modal"
                          data-target="#modalHoraires"
                        >
                          <div className="col-md-6 pr-0">
                            <div
                              className={`form-group ${this.errorClass(
                                this.state.formErrors[`numJour`]
                              )}`}
                            >
                              <input
                                type="text"
                                className="form-control custom-input ipt-id-jours"
                                name="numJour"
                                placeholder={this.props.t('info_creche.days')}
                                onClick={this.showModalHoraires}
                                readOnly
                                value={
                                  this.state.numJour > 0
                                    ? this.state.numJour + " " + this.props.t('info_creche.days')
                                    : ""
                                }
                              />
                              {(() => {
                                if (
                                  !_.isEmpty(this.state.formErrors["numJour"])
                                ) {
                                  return (
                                    <p>{this.state.formErrors["numJour"]}</p>
                                  );
                                } else {
                                  return "";
                                }
                              })()}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control custom-input ipt-id-jours"
                                name="horaire"
                                placeholder={this.props.t('info_creche.schedule')}
                                onClick={this.showModalHoraires}
                                readOnly
                                value={this.state.horaire}
                              />
                              {this.state.ModalHoraires ? (
                                <ModalHoraires
                                  handleChangeTimeEnd={this.handleChangeTimeEnd}
                                  handleChangeTimeStart={
                                    this.handleChangeTimeStart
                                  }
                                  horaireDebut={this.state.horaireDebut}
                                  horaireFin={this.state.horaireFin}
                                  horaires={this.state.newHoraires}
                                  handleChange={this.handleChangeHoraire}
                                  onClose={this.onCloseHorraires}
                                  onSubmitModal={this.onSubmitModal}
                                  title={this.props.t('info_creche.opening_hours')}
                                />
                              ) : (
                                ""
                              )}
                              {(() => {
                                if (
                                  !_.isEmpty(this.state.formErrors["numJour"])
                                ) {
                                  return (
                                    <p
                                      style={{
                                        marginTop: "45px",
                                      }}
                                    >
                                      {" "}
                                    </p>
                                  );
                                } else {
                                  return "";
                                }
                              })()}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-9">
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`rue`]
                          )}`}
                        >
                          <input
                            type="text"
                            id="adresse-etablissement"
                            placeholder={this.props.t('info_creche.address')}
                            className="form-control box-shadow custom-input ipt-id-adress2"
                            value={this.state.rue}
                            onChange={this.handleChange}
                            name="rue"
                          />
                          {(() => {
                            if (!_.isEmpty(this.state.formErrors["rue"])) {
                              return <p>{this.state.formErrors["rue"]}</p>;
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`codePostal`]
                          )}`}
                        >
                          <input
                            type="number"
                            id="cp-etablissement"
                            placeholder={this.props.t('info_creche.postal_code')}
                            className="form-control box-shadow custom-input ipt-id-adress2"
                            value={this.state.codePostal}
                            onChange={this.handleChange}
                            name="codePostal"
                          />
                          {(() => {
                            if (
                              !_.isEmpty(this.state.formErrors["codePostal"])
                            ) {
                              return (
                                <p>{this.state.formErrors["codePostal"]}</p>
                              );
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`ville`]
                          )}`}
                        >
                          <input
                            type="text"
                            id="ville-etablissement"
                            placeholder={this.props.t('info_creche.city')}
                            className="form-control box-shadow custom-input ipt-id-adress2"
                            value={this.state.ville}
                            onChange={this.handleChange}
                            name="ville"
                          />
                          {(() => {
                            if (!_.isEmpty(this.state.formErrors["ville"])) {
                              return <p>{this.state.formErrors["ville"]}</p>;
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`pays`]
                          )}`}
                        >
                          <input
                            value={this.state.pays}
                            onChange={this.handleChange}
                            type="text"
                            name="pays"
                            id="pays-etablissement"
                            placeholder={this.props.t('info_creche.country')}
                            className="form-control box-shadow custom-input ipt-id-adress2"
                          />
                          {(() => {
                            if (!_.isEmpty(this.state.formErrors["pays"])) {
                              return <p>{this.state.formErrors["pays"]}</p>;
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                      <div className="col-md-6 pr-0">
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`numeroTel`]
                          )}`}
                        >
                          <input
                            type="tel"
                            id="telephone-etablissement"
                            placeholder={this.props.t('info_creche.phone')}
                            className="form-control box-shadow custom-input ipt-id-tel"
                            value={this.state.numeroTel}
                            onChange={this.handleChange}
                            name="numeroTel"
                          />
                          {(() => {
                            if (
                              !_.isEmpty(this.state.formErrors["numeroTel"])
                            ) {
                              return (
                                <p>{this.state.formErrors["numeroTel"]}</p>
                              );
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div
                          className={`form-group ${this.errorClass(
                            this.state.formErrors[`email`]
                          )}`}
                        >
                          <input
                            type="email"
                            id="email-etablissement"
                            placeholder={this.props.t('info_creche.email')}
                            className="form-control box-shadow custom-input ipt-id-email"
                            value={this.state.email}
                            onChange={this.handleChange}
                            name="email"
                          />
                          {(() => {
                            if (!_.isEmpty(this.state.formErrors["email"])) {
                              return <p>{this.state.formErrors["email"]}</p>;
                            } else {
                              return "";
                            }
                          })()}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div
                      className="photo-enfant"
                      style={
                        this.state.showPhoto == null
                          ? divStyle(this.state.logoCreche)
                          : divStyle(
                              window.URL.createObjectURL(this.state.showPhoto)
                            )
                      }
                    >
                      {this.renderContent()}
                    </div>
                  </div>
                </div>
                <br />
                <h2 mt-3="true">{this.props.t('info_creche.staffing_thresholds')}</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`seuilStaffingGlobal`]
                      )}`}
                    >
                      <div
                        className="seuilStaffingGlobal"
                        style={{
                          left:
                            this.state.dynLeft["seuilStaffingGlobal"] + "em",
                          display: this.state.prefix["seuilStaffingGlobal"]
                            ? "inline-flex"
                            : "none",
                          width: "auto",
                        }}
                      >
                        {this.props.t('info_creche.min_staff')}
                      </div>
                      <input
                        value={this.state.seuilStaffingGlobal}
                        onChange={this.handleChange}
                        type="number"
                        name="seuilStaffingGlobal"
                        placeholder={this.props.t('info_creche.min_staff')}
                        className="form-control box-shadow custom-input ipt-id-nom"
                      />
                      {(() => {
                        if (
                          !_.isEmpty(
                            this.state.formErrors["seuilStaffingGlobal"]
                          )
                        ) {
                          return (
                            <p>
                              {this.state.formErrors["seuilStaffingGlobal"]}
                            </p>
                          );
                        } else {
                          return "";
                        }
                      })()}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`seuilRampeursParAgent`]
                      )}`}
                    >
                      <div
                        className="seuilRampeursParAgent"
                        style={{
                          left:
                            this.state.dynLeft["seuilRampeursParAgent"] + "em",
                          display: this.state.prefix["seuilRampeursParAgent"]
                            ? "inline-flex"
                            : "none",
                          width: "auto",
                        }}
                      >
                        bébés maximum par encadrant présent
                      </div>
                      <input
                        value={this.state.seuilRampeursParAgent}
                        onChange={this.handleChange}
                        type="number"
                        name="seuilRampeursParAgent"
                        placeholder={this.props.t('info_creche.max_babies_per_staff')}
                        className="form-control box-shadow custom-input ipt-id-nom"
                      />
                      {(() => {
                        if (
                          !_.isEmpty(
                            this.state.formErrors["seuilRampeursParAgent"]
                          )
                        ) {
                          return (
                            <p>
                              {this.state.formErrors["seuilRampeursParAgent"]}
                            </p>
                          );
                        } else {
                          return "";
                        }
                      })()}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div
                      className={`form-group ${this.errorClass(
                        this.state.formErrors[`seuilMarcheursParAgent`]
                      )}`}
                    >
                      <div
                        className="seuilMarcheursParAgent"
                        style={{
                          left:
                            this.state.dynLeft["seuilMarcheursParAgent"] + "em",
                          display: this.state.prefix["seuilMarcheursParAgent"]
                            ? "inline-flex"
                            : "none",
                          width: "auto",
                        }}
                      >
                        enfants maximum par encadrant présent
                      </div>
                      <input
                        value={this.state.seuilMarcheursParAgent}
                        onChange={this.handleChange}
                        type="number"
                        name="seuilMarcheursParAgent"
                        placeholder={this.props.t('info_creche.max_children_per_staff')}
                        className="form-control box-shadow custom-input ipt-id-nom"
                      />
                      {(() => {
                        if (
                          !_.isEmpty(
                            this.state.formErrors["seuilMarcheursParAgent"]
                          )
                        ) {
                          return (
                            <p>
                              {this.state.formErrors["seuilMarcheursParAgent"]}
                            </p>
                          );
                        } else {
                          return "";
                        }
                      })()}
                    </div>
                  </div>
                </div>
              </section>
              <section className="content-section">
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    onClick={this.handleSubmitInfos}
                    className="btn-gradient btn-valid"
                  >
                    <IconCheckWhite /> {this.props.t('common.validate')}
                  </button>
                </div>
              </section>
              <section className="content-section border-0 p-0 mt-5 fermeture-jour">
                <h2 className="mt-2">{this.props.t('info_creche.closure_date')}</h2>
                <div className="row align-items-center row-horaires">
                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        autoOk
                        ampm={false}
                        value={this.state.startDate}
                        onChange={this.handleChangeDateStart}
                        format={"DD MMM YYYY "}
                        minutesStep={5}
                        TextFieldComponent={this.renderInput}
                        textLabel={this.props.t('info_creche.start_date')}
                        disabled={this.state.initialized}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>

                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        autoOk
                        ampm={false}
                        value={this.state.endDate}
                        onChange={this.handleChangeDateEnd}
                        format={" DD MMM YYYY"}
                        minutesStep={5}
                        TextFieldComponent={this.renderInput}
                        textLabel={this.props.t('info_creche.end_date')}
                        disabled={this.state.initialized}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                </div>
              </section>
            </div>
            <div className="d-flex justify-content-center mb-3">
              <button
                type="submit"
                id="ajouterJourFermeture"
                className="btn-blue mr-3"
                onClick={this.handleSubmit}
                style={this.handleStyle()}
              >
                {this.props.t('info_creche.add_closure_date')}
              </button>
            </div>
            <section className="content-section mt-5 border-0 pb-2">
              <h2 className="mt-2">{this.props.t('info_creche.calendar')}</h2>

              <PlanningCreche
                dataPlanningCreche={this.props.dataPlanningCreche}
                successMsg={this.props.successMsg}
                handleClickFermeture={this.handleClickFermeture}
              />
            </section>
          </div>
        </div>
        {this.state.ModalDeleteFermeture ? (
          <ModalDeleteFermeture
            handleCloseFermeture={this.handleCloseFermeture}
            onSubmitSuppression={this.onSubmitSuppression}
          />
        ) : (
          ""
        )}
        {this.state.ModalePhoto ? (
          <ModalePhoto
            onCloseModalePhoto={this.onCloseModalePhoto}
            ModalePhoto={this.state.ModalePhoto}
            uploadPhoto={this.uploadPhoto}
            photo={this.state.lienPhoto}
          />
        ) : (
          ""
        )}
        {this.state.modalUploadMobile ? (
          <UploadMobile
            photo={this.state.file}
            onCloseUploadMobile={this.onCloseUploadMobile}
            getCroppedImage={this.getCroppedImage}
            uploadPhotoMobile={this.uploadPhotoMobile}
          />
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  dataCreche: state.gestionCreche.infos.data,
  dataPlanningCreche: state.gestionCreche.planningCreche.data,
  successMsg: state.successMsg.status,
});

const mapDispatchToProps = {
  getInfosCreche,
  getFermetures,
  postFermetures,
  deleteFermetures,
  putInfosCreche,
  updateLogoCreche
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InfoCreche));
